module.exports = __webpack_public_path__ + "img/dgitem6.eb35801c.png";